let google_places_script_promise = null;

export function get_first_value(...values) {
    return values.find((value) => value !== undefined && value !== null && value !== "") || "";
}

export function get_delivery_contact_details(user_details = {}, address = {}) {
    const first_name = get_first_value(
        user_details?.first_name,
    );
    const last_name = get_first_value(
        user_details?.last_name,
    );
    const full_name = [first_name, last_name].filter(Boolean).join(" ");

    return {
        contact_name: get_first_value(
            address?.contact_name,
            full_name,
            user_details?.name
        ),
        email: get_first_value(
            address?.email,
            user_details?.email,
        ),
        contact_phone: get_first_value(
            address?.contact_phone,
            user_details?.phone_number,
            user_details?.contact_phone,
        ),
    };
}

export function get_delivery_address_payload(address = {}) {
    return {
        address_id: address.address_id,
        contact_name: address.contact_name,
        email: address.email,
        contact_phone: address.contact_phone,
        street_address: address.street_address,
        suburb: address.suburb,
        city: address.city,
        province: address.province,
        postal_code: address.postal_code,
    };
}


export function load_google_places_script() {
    if (window.google?.maps?.places) {
        return Promise.resolve(window.google.maps);
    }

    if (google_places_script_promise) {
        return google_places_script_promise;
    }

    const api_key = process.env.VUE_APP_GOOGLE_MAP_API_KEY;

    if (!api_key) {
        return Promise.reject(new Error("Google Maps API key is missing."));
    }

    google_places_script_promise = new Promise((resolve, reject) => {
        const existing_script = document.getElementById("google-maps-places-script");

        if (existing_script) {
            existing_script.addEventListener("load", () => resolve(window.google.maps));
            existing_script.addEventListener("error", reject);
            return;
        }

        const script = document.createElement("script");
        script.id = "google-maps-places-script";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${api_key}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve(window.google.maps);
        script.onerror = () => reject(new Error("Could not load Google Places."));
        document.head.appendChild(script);
    });

    return google_places_script_promise;
}

function get_google_address_component(address_components = [], type) {
    return address_components
        .find((item) => item.types.includes(type))
        ?.long_name || "";
}

export function get_google_address_components(place = {}) {
    const address_components = place.address_components || [];
    return {
        street_number: get_google_address_component(address_components, "street_number"),
        route: get_google_address_component(address_components, "route"),
        sublocality_level_1: get_google_address_component(address_components, "sublocality_level_1"),
        sublocality: get_google_address_component(address_components, "sublocality"),
        neighborhood: get_google_address_component(address_components, "neighborhood"),
        locality: get_google_address_component(address_components, "locality"),
        administrative_area_level_2: get_google_address_component(address_components, "administrative_area_level_2"),
        administrative_area_level_1: get_google_address_component(address_components, "administrative_area_level_1"),
        postal_code: get_google_address_component(address_components, "postal_code"),
    };
}

export function get_google_place_address_fields(place = {}) {
    const components = get_google_address_components(place);
    const street_address = [
        components.street_number,
        components.route,
    ].filter(Boolean).join(" ");

    return {
        street_address: get_first_value(street_address, place.formatted_address),
        suburb: get_first_value(
            components.sublocality_level_1,
            components.sublocality,
            components.neighborhood
        ),
        city: get_first_value(
            components.locality,
            components.administrative_area_level_2
        ),
        province: get_first_value(components.administrative_area_level_1),
        postal_code: get_first_value(components.postal_code),
    };
}
